import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Vin'],
});

// Define a service using a base URL and expected endpoints
export const vinApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
 
    //  vin list
    findAllVinList: builder.mutation({
      query: (payload) => {
        let url = `vin_list/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null ) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['Vin'],
    }),
    findAllMasterDataVin: builder.query({
      query: () => `vin_list/selection_data/`,
      providesTags: ['Vin'],
    }),
    getPrintKakudaiData: builder.query({
      query: (payload) =>
        `print_kakudai/?calling_no=${payload.calling_no}&vin_no=${payload.vin_no}`,
      providesTags: ['Vin'],
    }),
    findAllEditVinData: builder.mutation({
      query: () => ({
        url: `vin_list/selection_data/edit_vin/`,
        method: 'GET',
      }),

      providesTags: ['Vin'],
    }),
    uploadVinListUpload: builder.mutation({
      query: (body) => ({
        url: `vin_list/upload_vins/`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['Vin'],
    }),
    editVinList: builder.mutation({
      query: (body) => ({
        url: `vin_list/edit_vins/`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['Vin'],
    }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUploadVinListUploadMutation,
  useFindAllVinListMutation,
  useFindAllMasterDataVinQuery,
  useFindAllEditVinDataMutation,
  useGetPrintKakudaiDataQuery,
  useEditVinListMutation,
} = vinApi;
